/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProgressData } from '../../../../actions';
import { NoReports, ProgressTable, TableFilter } from '../../../../components';
import { API_URLS, API_PARAMS, API_METHODS } from '../../../../constant';
import { getUserData, invoke } from '../../../../helpers';

const Progress = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [searchGlobal, setSearchGlobal] = useState(null);
  const dispatch = useDispatch();
  const ORG_ID = useSelector((state) => state.session.user.Org.id);
  const { data, loading } = useSelector((state) => state.progressTable);
  const userData = getUserData();

  const getUsersMemberships = (status = API_PARAMS.ACTIVE) => {
    return invoke({ url: API_URLS.ORG + userData.user.Org.id + '/groups', type: API_METHODS.GET, params: { status } });
  };
  const getUsersData = (status = API_PARAMS.ACTIVE) => {
    return invoke({
      url: API_URLS.ORG + userData.user.Org.id + '/report/progress',
      type: API_METHODS.GET,
      params: { status },
    });
  };

  const setFilterProps = (filters) => {
    if (!searchGlobal) setSearchGlobal(() => filters.setGlobalFilter);
  };

  const customFilter = (value) => setKeyword(value);

  const displayData = keyword
    ? filteredData.filter((item) => {
        const name = ((item.first_name || '') + ' ' + (item.last_name || '')).toUpperCase();
        return name.includes(keyword.toUpperCase()) || (item.group || '').toUpperCase().includes(keyword.toUpperCase());
      })
    : filteredData;

  useEffect(() => {
    const url = `${API_URLS.ORG}${ORG_ID}${API_URLS.REPORT}${API_URLS.PROGRESS}`;
    dispatch(getProgressData(url));
    getUsersData().then((result) => {
      getUsersMemberships().then((response) => {
        const map = {};
        let j = 1;
        for (let i = 0; i < response.length; i++) {
          if (response[i].member_access.split(',').includes(userData.user.id) && !map[response[i].name]) {
            map[response[i].name] = j++;
          }
        }
        const filterThis = result.filter((element) => map[element.group]);
        setFilteredData(filterThis);
      });
    });
  }, [ORG_ID]);
  return (
    <>
      <section className="panel table progress">
        {data.length ? (
          <>
            <header className="filter">
              <TableFilter searchGlobal={searchGlobal} customFilter={customFilter} placeholder="Search" />
            </header>
            <ProgressTable progressData={displayData} getFilterProps={setFilterProps} />
          </>
        ) : (
          <NoReports loading={loading} />
        )}
      </section>
    </>
  );
};

export default Progress;
